// extracted by mini-css-extract-plugin
export default {"figmaLoveZeplin":"A_OgjcyCA10KdyNVF3zE","figma":"G7WHyUiHfk9ZbKJrqMZA","hearts":"cm4bJMXreC079O7WF1pD"};